import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { AppInsightsService } from './appinsights.service';
export class AppInsightsModule {
/**
 * @param {?} instrumentationKey
 * @return {?}
 */
static forRoot(instrumentationKey: string): ModuleWithProviders {
    return {
      ngModule: AppInsightsModule,
      providers: [AppInsightsService, { provide: 'instrumentationKey', useValue: instrumentationKey }]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [],
  imports: [BrowserModule],
  exports: [],
  providers: [AppInsightsService],
  bootstrap: []
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AppInsightsModule_tsickle_Closure_declarations() {
/** @type {?} */
AppInsightsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AppInsightsModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
